/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Button, Card, Col, Row } from 'antd';
import { useSelector } from 'react-redux';
import { DisplayAmount } from 'components';

const FinancialEntrySummary = ({ onFilter }) => {
  const { summary = {} } = useSelector(
    (c) => c.resources['financial-entries'] ?? {}
  );

  const {
    amountReceipt = 0,
    amountPayment = 0,
    totalReceiptPending = 0,
    totalPaymentPending = 0,
    totalTransactions = 0,
    previousBalance = 0,
    balance = 0,
    dateType
  } = summary;

  const handleFilterReceiptPending = () => {
    onFilter({
      type: 'receipt',
      itemStatus: 'awaitingPayment'
    });
  };

  const handleFilterPaymentPending = () => {
    onFilter({
      type: 'payment',
      itemStatus: 'awaitingPayment'
    });
  };

  return (
    <div className="gx-container-app">
      <Card className="gx-card gx-mb-1" bodyStyle={{ padding: 10 }}>
        <div className="gx-flex-row gx-justify-content-between">
          <table>
            <tbody>
              <tr>
                <td className="gx-text-grey gx-pr-4">Receitas pendentes</td>
                <td className="gx-text-grey gx-pr-4">Despesas pendentes</td>
                <td className="gx-text-grey gx-pr-4">Lançamentos</td>
              </tr>
              <tr>
                <td className="gx-fs-lg gx-font-weight-semi-bold">
                  {totalReceiptPending > 0 ? (
                    <span
                      className="gx-pointer"
                      role="button"
                      onKeyDown={handleFilterReceiptPending}
                      onClick={handleFilterReceiptPending}
                      tabIndex={0}
                    >
                      {totalReceiptPending}
                    </span>
                  ) : (
                    totalReceiptPending
                  )}
                </td>
                <td className="gx-fs-lg gx-font-weight-semi-bold">
                  {totalPaymentPending > 0 ? (
                    <span
                      className="gx-pointer"
                      role="button"
                      onKeyDown={handleFilterPaymentPending}
                      onClick={handleFilterPaymentPending}
                      tabIndex={0}
                    >
                      {totalPaymentPending}
                    </span>
                  ) : (
                    totalPaymentPending
                  )}
                </td>
                <td className="gx-fs-lg gx-font-weight-semi-bold">
                  {totalTransactions}
                </td>
              </tr>
            </tbody>
          </table>

          <table className="gx-financialentrysummary-table">
            <tr>
              {dateType === 'dateOfCompensation' ? (
                <td className="gx-text-grey">Saldo Anterior</td>
              ) : null}
              <td className="gx-text-grey">Total de receitas</td>
              <td className="gx-text-grey">Total de despesas</td>
              {dateType === 'dateOfCompensation' ? (
                <td className="gx-text-grey">Saldo atual</td>
              ) : (
                <td className="gx-text-grey">Saldo</td>
              )}
            </tr>
            <tr>
              {dateType === 'dateOfCompensation' ? (
                <td className="gx-fs-lg gx-font-weight-semi-bold">
                  <DisplayAmount amount={previousBalance} />
                </td>
              ) : null}
              <td className="gx-fs-lg gx-font-weight-semi-bold">
                <DisplayAmount amount={amountReceipt} />
              </td>
              <td className="gx-fs-lg gx-font-weight-semi-bold">
                <DisplayAmount amount={amountPayment} />
              </td>
              <td className="gx-fs-lg gx-font-weight-semi-bold">
                <DisplayAmount amount={balance} />
              </td>
            </tr>
          </table>
        </div>
      </Card>
    </div>
  );
};

export default FinancialEntrySummary;
